<template>
  <div style="width: 100%">
    <div class="dc-bar">
      <div class="dc-nav">
        <div class="dc-pair">
          <button
            type="button"
            class="dc-btn"
            :title="navTip('Prev')"
            @click="$refs.calendar.prev()"
          >
            <v-icon size="18">
              mdi-chevron-right
            </v-icon>
          </button>
          <button
            type="button"
            class="dc-btn"
            :title="navTip('Next')"
            @click="$refs.calendar.next()"
          >
            <v-icon size="18">
              mdi-chevron-left
            </v-icon>
          </button>
        </div>
        <button
          type="button"
          class="dc-btn dc-btn--text"
          @click="goToday"
        >
          {{ $t('today') }}
        </button>
        <span
          class="dc-period"
          dir="auto"
        >{{ periodLabel }}</span>
      </div>
      <div class="dc-tools">
        <div class="dc-date input-minimal">
          <v-text-field
            id="sDate"
            v-model="focusDate"
            :placeholder="$t('date')"
            prepend-inner-icon="mdi-calendar-search"
            outlined
            dense
            hide-details
            clearable
          />
          <date-picker
            v-model="focusDate"
            element="sDate"
            :locale="$store.state.date_locale"
            :format="$store.state.date_format"
            auto-submit
            :min="$store.state.startDate"
            :max="$store.state.endDate"
            :color="this.$vuetify.theme.themes[this.$vuetify.theme.isDark ? 'dark' : 'light'].primary"
            @close="setDate"
          />
        </div>
        <div
          class="dc-seg"
          role="tablist"
        >
          <button
            v-for="t in types"
            :key="t.value"
            type="button"
            class="dc-seg-opt"
            :class="{ 'is-active': type === t.value }"
            @click="type = t.value"
          >
            {{ t.text }}
          </button>
        </div>
        <button
          v-if="!selectedMoveStatus && !typeProp"
          type="button"
          class="dc-btn dc-btn--icon"
          :title="$t('makeEvent')"
          @click="selectedMoveStatus = 'create'"
        >
          <v-icon size="18">
            mdi-table-plus
          </v-icon>
        </button>
        <span
          v-if="selectedMoveStatus == 'create'"
          class="dc-hint"
        >
          {{ $t('forCreateClickOnCalenderInCategoryMode') }}
        </span>
        <v-menu
          v-if="!isMobile"
          offset-y
          left
          :close-on-content-click="false"
        >
          <template v-slot:activator="{ on, attrs }">
            <button
              type="button"
              class="dc-btn dc-btn--icon"
              :title="$t('calendarSettings')"
              v-bind="attrs"
              v-on="on"
            >
              <v-icon size="18">
                mdi-tune-variant
              </v-icon>
            </button>
          </template>
          <div class="dc-menu input-minimal">
            <v-text-field
              v-model="intervalHeight"
              :label="$t('intervalHeight')"
              outlined
              dense
              hide-details
              type="number"
              :rules="numberRules"
              @focus="focusEvent"
            />
          </div>
        </v-menu>
        <button
          v-if="type !== 'category'"
          type="button"
          class="dc-btn dc-btn--icon"
          :disabled="!hasColWidths"
          :title="$t('calResetColumns')"
          @click="resetAllColWidths"
        >
          <v-icon size="18">
            mdi-arrow-collapse-horizontal
          </v-icon>
        </button>
        <button
          type="button"
          class="dc-btn dc-btn--icon"
          :class="{ 'is-active': filterActive }"
          :title="$t('filter')"
          @click="filter = true"
        >
          <v-icon size="18">
            mdi-filter-variant
          </v-icon>
          <span
            v-if="filterActive"
            class="dc-badge"
          />
        </button>
      </div>
    </div>
    <v-sheet :height="(heightProp ? heightProp : '300')">
      <v-calendar
        ref="calendar"
        v-model="focus"
        style="border-bottom: #e0e0e0 1px solid;"
        locale="fa"
        :weekdays="weekday"
        :type="type"
        :events="displayEvents"
        :weekday-format="getDay"
        event-overlap-mode="column"
        :event-overlap-threshold="60"
        :categories="categories"
        category-show-all
        category-text="name"
        :hide-header="false"
        @change="onRange"
        @mousedown:event="onEventDown"
        @mousedown:time-category="startTimeEvent"
        @mousemove:time-category="mouseMove"
        @mouseup:time-category="endDrag"
        @mousedown:time="startTimeEvent"
        @mousemove:time="mouseMove"
        @mouseup:time="endDrag"
        @click:event="onEventClick"
        @click:more="viewDay"
        @click:date="viewDay"
        @mouseleave.native="cancelDrag"
        :interval-height="intervalHeight"
      >
        <template
          v-slot:day-label-header="{}"
        >
<!--          <v-row style="height: 50px ;" />-->
        </template>
<!--                <template v-slot:day-header="{}">-->
<!--                  <v-row style="height: 50px">-->
<!--                  </v-row>-->
<!--                </template>-->
        <template v-slot:event="{ event, eventParsed, timed, eventSummary }">
          <div
            v-if="event.isMore"
            class="dc-more"
            :title="$t('calMoreSessions', { count: event.hidden.length })"
          >
            +{{ event.hidden.length }}
          </div>
          <session
            v-else
            :event="event"
            :timed="timed"
            :event-parsed="eventParsed"
            :event-summary="eventSummary"
            @extendBottom="extendBottom"
          />
        </template>
      </v-calendar>
      <v-menu
        v-model="more.open"
        :position-x="more.x"
        :position-y="more.y"
        absolute
        offset-y
        max-height="360"
        :close-on-content-click="true"
      >
        <div class="dc-more-list">
          <div class="dc-more-head">
            {{ $t('calMoreSessions', { count: more.items.length }) }}
          </div>
          <button
            v-for="(e, k) in more.items"
            :key="(e.id || 'n') + '-' + k"
            type="button"
            class="dc-more-item"
            @click="showEvent({ nativeEvent: $event, event: e })"
          >
            <span
              class="dc-more-dot"
              :style="{ background: e.color }"
            />
            <span class="dc-more-name">{{ e.name }}</span>
            <span class="dc-more-time">{{ timeLabel(e.start) }}–{{ timeLabel(e.end) }}</span>
          </button>
          <button
            type="button"
            class="dc-more-day"
            @click="viewDay({ date: more.date })"
          >
            <v-icon size="16">
              mdi-calendar-today
            </v-icon>
            {{ $t('calOpenDay') }}
          </button>
        </div>
      </v-menu>
      <v-dialog
      :fullscreen="isMobile"
      :hide-overlay="isMobile"
        v-model="selectedOpen"
        width="580px"
      >
        <session-modal
          :selected-event="selectedEvent"
          @close="selectedOpen = false"
          @setMoveStatus="setMoveStatus"
          @removeEvent="removeEvent"
          @updateTeacher="updateTeacher"
          @updateStatus="updateStatusTrigger"
        />
      </v-dialog>
    </v-sheet>
    <v-snackbar
      v-model="snackbar"
      :color="(snackbarColor ? snackbarColor : '')"
      top
      style="z-index: 1000000000000 !important;"
    >
      {{ snackbarText }}

      <template v-slot:action="{ attrs }">
        <v-btn
          color="white"
          text
          v-bind="attrs"
          @click="snackbar = !snackbar"
        >
          {{ $t('close') }}
        </v-btn>
      </template>
    </v-snackbar>
    <v-dialog
      v-model="filter"
      :fullscreen="isMobile"
      :hide-overlay="isMobile"
      max-width="720"
      scrollable
      content-class="acf-wrap"
    >
      <div class="acf acf--compact" :style="proListRootStyle" dir="rtl">
        <header class="acf-head">
          <span class="acf-head__icon">
            <v-icon size="18">mdi-filter-variant</v-icon>
          </span>
          <div class="acf-head__titles">
            <div class="acf-head__title">{{ $t("academyCalendarFilterTitle") }}</div>
            <div class="acf-head__sub">
              <template v-if="activeFilterChips.length">
                <span class="acf-badge">{{ faNum(activeFilterChips.length) }}</span>
                {{ $t("accFilterActive") }}
              </template>
              <template v-else>{{ $t("accFilterNone") }}</template>
            </div>
          </div>
          <button type="button" class="acf-x" :title="$t('close')" @click="filter = false">
            <v-icon size="18">mdi-close</v-icon>
          </button>
        </header>

        <div class="acf-body">

          <section class="acf-sec">
            <div class="acf-sec__head">
              <v-icon size="17">mdi-filter-variant</v-icon>
              {{ $t("academyFilterBasics") }}
            </div>
            <div class="acf-grid acf-grid--3">
              <autocomplete
                v-model="branch"
                :title="$t('branch')"
                type="branch"
                :value="branch"
              />
              <autocomplete
                v-model="place"
                title="academyPlace"
                type="academyPlace"
                :multiple="true"
              />
              <autocomplete
                v-if="!$store.state.accessType"
                v-model="teacher"
                title="teacher"
                type="person"
                :new-btn="true"
                :data="JSON.stringify({type: 'teacher'})"
              />
            </div>
          </section>
        </div>

        <footer class="acf-foot">
          <button type="button" class="acf-btn acf-btn--primary" @click="getEvents">
            <v-icon size="16">mdi-filter-check-outline</v-icon>
            {{ $t("accFilterApply") }}
          </button>
          <button
            type="button"
            class="acf-btn acf-btn--ghost"
            :disabled="!activeFilterChips.length"
            @click="resetFilters"
          >
            <v-icon size="16">mdi-filter-remove-outline</v-icon>
            {{ $t("accDocListClearFilters") }}
          </button>
          <span class="acf-spacer" />
          <button type="button" class="acf-btn" @click="filter = false">
            {{ $t("cancel") }}
          </button>
        </footer>
      </div>
    </v-dialog>
  </div>
</template>

<script>
  // Local copy of ./calender.vue (shared with event.vue / home.vue) with the academy dashboard toolbar.
  import Session from './session'
  import SessionModal from './dashboardSessionModal'
  import aicomplete from '../../../components/general/AIcomplete/index'
  export default {
    name: 'AcademyDashboardCalender',
    components: {
      aicomplete,
      Session,
      SessionModal,
    },
    props: ['eventsProp', 'startTime', 'teacherProp', 'placeProp', 'typeProp', 'heightProp'],
    data: () => ({
      focus: '',
      numberRules: [
        v => !!v || 'This field is required',
        v => (v && v >= 0) || 'The number must be bigger than zero',
      ],
      intervalHeight: 48,
      branch: null,
      focusDate: null,
      type: 'week',
      types: ['week', '4day'],
      mode: 'stack',
      modes: ['stack', 'column'],
      weekday: [6, 0, 1, 2, 3, 4, 5],
      categories: [],
      weekdays: [
        { text: 'Sun - Sat', value: [6, 0, 1, 2, 3, 4, 5] },
        { text: 'Mon - Sun', value: [6, 0, 1, 2, 3, 4, 5] },
        { text: 'Mon - Fri', value: [6, 0, 1, 2, 3, 4, 5] },
        { text: 'Mon, Wed, Fri', value: [1, 3, 5] },
      ],
      value: '',
      filter: false,
      editName: false,
      snackbar: false,
      snackbarColor: null,
      teacher: null,
      place: null,
      allPlace: null,
      snackbarText: null,
      weekEvents: null,
      selectedEvent: {},
      tempEvent: {},
      selectedElement: null,
      updateStatus: false,
      selectedOpen: false,
      selectedMoveStatus: null,
      timer: 0,
      events: [],
      range: null,
      maxPerSlot: 3,
      // day-column resize (week / 4-day): widths per weekday, measured px per date
      colWidths: {},
      colPx: {},
      more: { open: false, x: 0, y: 0, items: [], date: null },
    }),
    computed: {

      proListRootStyle () {
        var theme = this.$vuetify.theme
        var t = theme.themes[theme.isDark ? 'dark' : 'light'] || {}
        var primary = typeof t.primary === 'string' ? t.primary : (t.primary && t.primary.base) || '#1976d2'
        return { '--pl-primary': primary, '--pl-primary-soft': primary + '1a' }
      },

      activeFilterChips () {
        var app = this

      var has = function (v) {
        if (Array.isArray(v)) return v.length > 0
        return v !== null && v !== undefined && v !== '' && v !== '0' && v !== 0
      }
      var show = function (v) {
        if (Array.isArray(v)) return v.length > 1 ? String(v.length) : show(v[0])
        if (v && typeof v === 'object') return v.name || v.text || v.label || ''
        return typeof v === 'number' || typeof v === 'string' ? String(v) : ''
      }

        var defs = [
          ['branch', app.$t('branch')],
          ['place', app.$t('academyPlace')],
          ['teacher', app.$t('teacher')],
        ]
        return defs
          .filter(function (d) {
            return has(app[d[0]])
          })
          .map(function (d) {
            return { key: d[0], label: d[1], value: d.length > 2 ? d[2] : show(app[d[0]]) }
          })
      },
      hasColWidths () {
        return Object.keys(this.colWidths).length > 0
      },
      // Week / 4-day: show at most maxPerSlot overlapping sessions, the rest go into a "+N" item
      displayEvents () {
        if (this.type === 'category' || !this.events) return this.events
        const ms = v => (typeof v === 'number' ? v : new Date(String(v).replace(' ', 'T')).getTime())
        const pinned = [this.dragEvent, this.createEvent, this.selectedEvent]
        const byDay = {}
        this.events.forEach(e => {
          const d = new Date(ms(e.start))
          const key = this.$moment(d).format('YYYY-MM-DD')
          ;(byDay[key] = byDay[key] || []).push(e)
        })
        const out = []
        Object.keys(byDay).forEach(key => {
          const list = byDay[key].slice().sort((a, b) => ms(a.start) - ms(b.start))
          let group = []
          let groupEnd = -Infinity
          const flush = () => {
            const max = this.slotLimit(key)
            if (group.length <= max) {
              out.push(...group)
            } else {
              const keep = group.filter(e => pinned.includes(e)).slice(0, max)
              group.forEach(e => { if (keep.length < max && !keep.includes(e)) keep.push(e) })
              const hidden = group.filter(e => !keep.includes(e))
              out.push(...keep)
              if (hidden.length) {
                const d = new Date(ms(group[0].start))
                out.push({
                  isMore: true,
                  name: '+' + hidden.length,
                  color: 'transparent',
                  timed: true,
                  status: 'more',
                  start: Math.min(...group.map(e => ms(e.start))),
                  end: Math.max(...group.map(e => ms(e.end))),
                  date: this.$moment(d).format('YYYY-MM-DD'),
                  hidden,
                  all: group,
                })
              }
            }
            group = []
            groupEnd = -Infinity
          }
          list.forEach(e => {
            if (group.length && ms(e.start) >= groupEnd) flush()
            group.push(e)
            groupEnd = Math.max(groupEnd, ms(e.end))
          })
          flush()
        })
        return out
      },
      filterActive () {
        return !!(this.branch || this.teacher || (this.place && this.place.length))
      },
      periodLabel () {
        if (!this.range) return ''
        // instance-level locale only: other dates/times in the app keep their format
        const loc = this.$store.state.date_locale === 'en,fa' ? 'en' : 'fa'
        const s = this.$moment(this.range.start, 'YYYY-MM-DD').locale(loc)
        const e = this.$moment(this.range.end, 'YYYY-MM-DD').locale(loc)
        if (this.range.start === this.range.end) return s.format('dddd jD jMMMM jYYYY')
        if (s.jMonth() === e.jMonth()) return s.format('jD') + ' – ' + e.format('jD jMMMM jYYYY')
        return s.format('jD jMMMM') + ' – ' + e.format('jD jMMMM jYYYY')
      },
    },
    watch: {
      eventsProp () {
        this.events = [
          ...this.weekEvents,
          ...Array.from(this.eventsProp),
        ]
        this.$refs.calendar.scrollToTime(this.startTime)
      },
      placeProp () {
        this.getEvents({})
      },
      place (val) {
        this.categories = this.allPlace
        if (val && val.length > 0) {
          this.categories = val
        }
      },
    },
    beforeMount () {
      if (this.typeProp) {
        this.type = this.typeProp
      }
    },
    updated () {
      this.scheduleColResize()
    },
    beforeDestroy () {
      clearTimeout(this.colTimer)
      window.removeEventListener('resize', this.measureCols)
    },
    activated: function () {
      if (this.events.length > 0) {
        this.$refs.calendar.scrollToTime(this.events[0].start_time)
      }
    },
    mounted () {
      this.types = [
        {
          value: 'week',
          text: this.$t('week'),
        },
        {
          value: 'category',
          text: this.$t('daily'),
        },
        {
          value: '4day',
          text: this.$t('4day'),
        },
      ]
      this.selectedMoveStatus = null
      this.getPlaces()
      try {
        this.colWidths = JSON.parse(localStorage.getItem('academyCalColWidths') || '{}') || {}
      } catch (e) {
        this.colWidths = {}
      }
      window.addEventListener('resize', this.measureCols)
      this.scheduleColResize()
    },
    methods: {
      faNum (v) {
        if (v == null || v === '') return ''
        var map = { '0': '۰', '1': '۱', '2': '۲', '3': '۳', '4': '۴', '5': '۵', '6': '۶', '7': '۷', '8': '۸', '9': '۹' }
        return String(v).replace(/[0-9]/g, function (d) { return map[d] || d })
      },
      resetFilters () {
        var app = this
        ;['branch', 'place', 'teacher'].forEach(function (k) { app[k] = null })
      },
      // cards side by side in one day column: one per ~72px, at least 1
      slotLimit (date) {
        const px = this.colPx[date]
        if (!px) return this.maxPerSlot
        return Math.max(1, Math.min(8, Math.floor(px / 72)))
      },
      colDates () {
        if (!this.range) return []
        const out = []
        const s = this.$moment(this.range.start, 'YYYY-MM-DD')
        const e = this.$moment(this.range.end, 'YYYY-MM-DD')
        for (const d = s.clone(); !d.isAfter(e); d.add(1, 'day')) out.push(d.format('YYYY-MM-DD'))
        return out
      },
      colCells () {
        const root = this.$refs.calendar && this.$refs.calendar.$el
        if (!root || this.type === 'category') return null
        return {
          head: Array.from(root.querySelectorAll('.v-calendar-daily__head .v-calendar-daily_head-day')),
          body: Array.from(root.querySelectorAll('.v-calendar-daily__day-container .v-calendar-daily__day')),
        }
      },
      scheduleColResize () {
        clearTimeout(this.colTimer)
        this.colTimer = setTimeout(() => {
          if (document.body.classList.contains('column-resize--dragging')) return
          this.bindColHandles()
        }, 0)
      },
      applyColWidths () {
        const cells = this.colCells()
        if (!cells) return
        const dates = this.colDates()
        const apply = (el, i) => {
          if (!el) return
          const w = dates[i] ? this.colWidths[this.$moment(dates[i], 'YYYY-MM-DD').day()] : null
          el.style.flex = w ? '0 0 ' + w + 'px' : ''
          el.style.minWidth = w ? w + 'px' : '80px'
        }
        cells.head.forEach(apply)
        cells.body.forEach(apply)
      },
      measureCols () {
        const cells = this.colCells()
        if (!cells) return
        const dates = this.colDates()
        const px = {}
        cells.body.forEach((el, i) => { if (dates[i]) px[dates[i]] = el.offsetWidth })
        if (JSON.stringify(px) !== JSON.stringify(this.colPx)) this.colPx = px
      },
      bindColHandles () {
        const cells = this.colCells()
        if (!cells) return
        this.applyColWidths()
        const dates = this.colDates()
        cells.head.forEach((th, i) => {
          if (!dates[i] || th.querySelector('.column-resize-handle')) return
          th.classList.add('column-resize-th')
          const handle = document.createElement('div')
          handle.className = 'column-resize-handle'
          handle.title = this.$t('calResizeHint')
          const icon = document.createElement('i')
          icon.className = 'column-resize-min-icon mdi mdi-lock-outline'
          handle.appendChild(icon)
          handle.addEventListener('mousedown', ev => this.startColResize(ev, i))
          handle.addEventListener('dblclick', ev => this.resetColWidth(ev, i))
          th.appendChild(handle)
        })
        this.measureCols()
      },
      startColResize (ev, index) {
        ev.preventDefault()
        ev.stopPropagation()
        const dates = this.colDates()
        if (!dates[index]) return
        const wd = this.$moment(dates[index], 'YYYY-MM-DD').day()
        const handle = ev.currentTarget
        const startX = ev.clientX
        const startWidth = handle.parentElement.offsetWidth
        const rtl = this.$vuetify.rtl || getComputedStyle(handle).direction === 'rtl'
        const min = 80
        // keep every other day at least min wide so the grid never overflows
        const cells = this.colCells()
        const total = cells.body.reduce((t, el) => t + el.offsetWidth, 0)
        const others = dates.filter((d, k) => k !== index).reduce((t, d) => {
          const w = this.colWidths[this.$moment(d, 'YYYY-MM-DD').day()]
          return t + (w || min)
        }, 0)
        const max = Math.max(min, total - others)
        handle.classList.add('is-active')
        document.body.classList.add('column-resize--dragging')
        const move = e => {
          const raw = startWidth + (rtl ? startX - e.clientX : e.clientX - startX)
          const atMin = raw <= min
          handle.classList.toggle('is-min', atMin)
          this.$set(this.colWidths, wd, Math.round(atMin ? min : Math.min(raw, max)))
          this.applyColWidths()
        }
        const up = () => {
          handle.classList.remove('is-active', 'is-min')
          document.body.classList.remove('column-resize--dragging')
          document.removeEventListener('mousemove', move)
          document.removeEventListener('mouseup', up)
          this.saveColWidths()
          this.measureCols()
        }
        document.addEventListener('mousemove', move)
        document.addEventListener('mouseup', up)
      },
      resetColWidth (ev, index) {
        ev.stopPropagation()
        const dates = this.colDates()
        if (!dates[index]) return
        this.$delete(this.colWidths, this.$moment(dates[index], 'YYYY-MM-DD').day())
        this.applyColWidths()
        this.saveColWidths()
        this.$nextTick(this.measureCols)
      },
      resetAllColWidths () {
        this.colWidths = {}
        this.applyColWidths()
        this.saveColWidths()
        this.$nextTick(this.measureCols)
      },
      saveColWidths () {
        try {
          localStorage.setItem('academyCalColWidths', JSON.stringify(this.colWidths))
        } catch (e) {}
      },
      onEventDown (arg) {
        if (arg.event && arg.event.isMore) return
        this.startDrag(arg)
      },
      onEventClick ({ nativeEvent, event }) {
        if (!event.isMore) return this.showEvent({ nativeEvent, event })
        nativeEvent.stopPropagation()
        this.more.items = event.all
        this.more.date = event.date
        this.more.x = nativeEvent.clientX
        this.more.y = nativeEvent.clientY
        this.more.open = false
        this.$nextTick(() => { this.more.open = true })
      },
      timeLabel (v) {
        return this.$moment(typeof v === 'number' ? v : String(v).replace(' ', 'T')).format('HH:mm')
      },
      onRange (r) {
        this.range = { start: r.start.date, end: r.end.date }
        this.getEvents(r)
      },
      goToday () {
        this.focusDate = null
        this.focus = ''
      },
      navTip (dir) {
        const unit = this.type === 'week' ? 'Week' : (this.type === '4day' ? '4day' : 'Day')
        return this.$t('cal' + dir + unit)
      },
      setDate: function () {
        var m = this.$moment()
        this.focus = this.$moment(this.focusDate, 'jYYYY/jM/jD').format('YYYY-MM-DD')
        if (!this.focusDate) {
          var today = ''
          if (this.$store.state.date_locale === 'fa,en') {
            today = m.format('jYYYY/jMM/jDD')
          }
          if (this.$store.state.date_locale === 'en,fa') {
            today = m.format('YYYY/MM/DD')
          }
          if (today < this.$store.state.startDate) {
            today = this.$store.state.startDate
          }
          if (today > this.$store.state.endDate) {
            today = this.$store.state.endDate
          }
          this.focusDate = today
          return today
        }
      },
      removeEvent () {
        const i = this.events.indexOf(this.selectedEvent)
        this.selectedOpen = false
        if (i !== -1) {
          this.deleteEvent(this.selectedEvent)
          this.events.splice(i, 1)
        }
        this.selectedEvent = {}
        this.selectedMoveStatus = null
      },
      setMoveStatus (status) {
        this.selectedMoveStatus = status
        this.selectedOpen = false
      },
      viewDay ({ date, y }) {
        this.focus = date
        this.type = 'category'
      },
      showEvent ({ nativeEvent, event }) {
        var app = this
        const open = () => {
          this.selectedEvent = event
          this.selectedElement = nativeEvent.target
          requestAnimationFrame(() => requestAnimationFrame(function () {
            app.selectedOpen = true
          }))
        }

        if (this.selectedOpen) {
          this.selectedOpen = false
          requestAnimationFrame(() => requestAnimationFrame(function () {
            open()
          }))
        } else {
          open()
        }
        nativeEvent.stopPropagation()
      },
      getDay (date) {
        var m1 = this.$moment(date.date)
        var format = 'dddd - D MMM'
        var locale = 'en'
        if (this.$store.state.date_locale === 'fa,en') {
          format = 'dddd - jD jMMM'
          locale = 'fa'
        }
        return m1.locale(locale).format(format)
      },
      getPlaces () {
        var app = this
        app.loading = true
        app.clearing = true
        app.showing = true
        app.$axios.get(this.$endpoint + 'getdetail', {
          params: {
            select: 'academyPlacesAll',
          },
        })
          .then(res => {
            res = res.data
            app.allPlace = res
            app.categories = res
          })
          .catch(err => {
            app.serverErrorHandeler(err)
          })
          .finally(() => (app.loading = false))
      },
      getEvents ({ start, end }) {
        var app = this
        app.loading = true
        app.clearing = true
        app.showing = true
        app.$axios.get(this.$endpoint + 'academySession', {
          params: {
            getEvents: 'active',
            start: (start ? start.date : null),
            end: (end ? end.date : null),
            teacherAccess: (app.$store.state.teacherAccess === 'active' ? 'active' : null),
            teacher: (app.teacherProp ? app.teacherProp : app.teacher),
            place: (app.teacherProp ? app.teacherProp : app.place),
            branch: app.branch,
            mode: app.type,
          },
        })
          .then(res => {
            res = res.data
            app.weekEvents = res
            app.events = [
              ...Array.from(res),
              ...(app.eventsProp ? app.eventsProp : []),
            ]
            app.$refs.calendar.scrollToTime((app.events && app.events[0] !== undefined ? app.events[0].start_time : '12:00'))
          })
          .catch(err => {
            app.serverErrorHandeler(err)
          })
          .finally(() => (app.loading = false))
      },
      getEventColor (event) {
        return event.color
      },
      startDrag ({ event, timed }) {
        if (event && timed && !event.status && this.$store.state.admin === 'active') {
          this.dragEvent = event
          this.dragTime = null
          this.extendOriginal = null
        }
      },
      startTimeEvent (tms) {
        if (this.$store.state.admin === 'active') {
          const mouse = this.toTime(tms)
          var category = tms.category
          if (this.dragEvent && this.dragTime === null && !this.dragEvent.status) {
            const start = this.dragEvent.start
            this.dragTime = mouse - start
          } else {
            if (this.selectedMoveStatus === 'copy' || this.selectedMoveStatus === 'move') {
              if (this.selectedEvent && this.selectedEvent.name !== undefined) {
                this.makeEvent(mouse, category)
              }
            }
            if (this.selectedMoveStatus === 'create' && this.eventsProp) {
              this.selectedEvent = this.eventsProp[0]
              this.selectedEvent.category = this.placeProp.name
              this.makeEvent(mouse, category)
            }
          }
        }
      },
      updateTeacher (data) {
        const i = this.events.indexOf(data.event)
        this.events[i].teacher = data.teacher
        this.events[i].teacher_id = data.teacher.id
        this.events[i].teacher_cost = data.teacher_cost
      },
      updateEvent (event) {
        var app = this
        app.loading = true
        app.$axios.put(this.$endpoint + 'academySession/' + event.id, event)
          .then(res => {
            res = res.data
          })
          .catch(err => {
            app.serverErrorHandeler(err)
          })
          .finally(() => (app.loading = false))
      },
      storeEvent (event, j) {
        var app = this
        app.loading = true
        app.$axios.post(this.$endpoint + 'academySession', event)
          .then(res => {
            res = res.data.data
            app.events[j].id = res.id
            app.createEvent = null
          })
          .catch(err => {
            app.serverErrorHandeler(err)
          })
          .finally(() => (app.loading = false))
      },
      deleteEvent (event) {
        var app = this
        app.loading = true
        app.$axios.delete(this.$endpoint + 'academySession/' + event.id, event)
          .then(res => {
            res = res.data
          })
          .catch(err => {
            app.serverErrorHandeler(err)
          })
          .finally(() => (app.loading = false))
      },
      makeEvent (mouse, category) {
        if (this.selectedEvent && this.selectedEvent.name !== undefined) {
          this.createStart = this.roundTime(mouse)
          var duration = this.selectedEvent.end - this.selectedEvent.start
          this.createEvent = {
            name: this.selectedEvent.name + (this.selectedMoveStatus === 'copy' ? ' - copy' : ''),
            color: this.selectedEvent.color,
            date: this.selectedEvent.date,
            id: this.selectedEvent.id,
            copiedId: this.selectedEvent.id,
            teacher_cost: this.selectedEvent.teacher_cost,
            teacher: this.selectedEvent.teacher,
            event_id: this.selectedEvent.event_id,
            start: this.createStart,
            startOriginal: this.createStart,
            end: +this.createStart + +duration,
            endOriginal: +this.createStart + +duration,
            timed: true,
            category: (category !== undefined ? category.name : this.selectedEvent.category),
          }
          this.events.push(this.createEvent)
          const i = this.events.indexOf(this.selectedEvent)
          if (this.selectedMoveStatus === 'move') {
            if (i !== -1) {
              this.events.splice(i, 1)
            }
            this.updateEvent(this.createEvent)
          }
          const j = this.events.indexOf(this.createEvent)
          if (this.selectedMoveStatus === 'copy') {
            this.storeEvent(this.createEvent, j)
          }
          this.overlapCheck(this.createEvent, j)
          this.selectedEvent = {}
          this.selectedMoveStatus = null
        }
      },
      updateStatusTrigger (status) {
        this.selectedEvent.status = status
      },
      extendBottom (event) {
        if (!event.status && this.$store.state.admin === 'active') {
          this.createEvent = event
          this.createStart = event.start
          this.extendOriginal = event.end
          this.updateStatus = true
        }
      },
      mouseMove (tms) {
        var app = this
        const mouse = this.toTime(tms)
        if (this.dragEvent && this.dragTime !== null) {
          const i = this.events.indexOf(this.dragEvent)
          const start = this.dragEvent.start
          const end = this.dragEvent.end
          const duration = end - start
          const newStartTime = mouse - this.dragTime
          const newStart = this.roundTime(newStartTime)
          const newEnd = newStart + duration
          this.dragEvent.start = newStart
          this.dragEvent.end = newEnd
          clearTimeout(this.timer)
          var event = this.dragEvent
          this.updateStatus = true
          this.timer = setTimeout(function () {
            app.overlapCheck(event, i)
          }, 1000)
        } else if (this.createEvent && this.createStart !== null) {
          const mouseRounded = this.roundTime(mouse, false)
          const min = Math.min(mouseRounded, this.createStart)
          const max = Math.max(mouseRounded, this.createStart)
          this.createEvent.start = min
          this.createEvent.end = max
        }
      },
      overlapCheck (event, i) {
        const start = event.start
        const end = event.end
        var app = this
        var check = true
        for (var index = 0; index < this.events.length; index++) {
          var value = this.events[index]
          if (index !== i && value.category === event.category) {
            if (start >= value.start && start < value.end) {
              check = false
            }
            if (end > value.start && end <= value.end) {
              check = false
            }
          }
          if (!check && i !== index) {
            app.snackbarText = app.$t('overlap') + ' ' + event.name + ' ' + app.$t('with') + ' ' + value.name
            app.snackbarColor = 'pink'
            app.snackbar = true
            if (event.startOriginal) {
              event.start = event.startOriginal
              event.end = event.endOriginal
            } else {
              app.events.splice(i, 1)
            }
            app.updateEvent(event)
            break
          }
        }
        if (check) {
          event.startOriginal = start
          event.endOriginal = end
        }
      },
      endDrag () {
        if (this.dragEvent && this.dragEvent.id && this.updateStatus) {
          this.updateEvent(this.dragEvent)
        }
        if (this.createEvent && this.createEvent.id && this.updateStatus) {
          this.updateEvent(this.createEvent)
        }
        this.dragTime = null
        this.dragEvent = null
        this.createEvent = null
        this.updateStatus = false
        this.createStart = null
        this.extendOriginal = null
      },
      cancelDrag () {
        if (this.createEvent) {
          if (this.extendOriginal) {
            this.createEvent.end = this.extendOriginal
          } else {
            const i = this.events.indexOf(this.createEvent)
            if (i !== -1) {
              this.events.splice(i, 1)
            }
          }
        }
        this.createEvent = null
        this.createStart = null
        this.dragTime = null
        this.dragEvent = null
        this.updateStatus = false
      },
      roundTime (time, down = true) {
        const roundTo = 15 // minutes
        const roundDownTime = roundTo * 60 * 1000
        return down
          ? time - time % roundDownTime
          : time + (roundDownTime - (time % roundDownTime))
      },
      toTime (tms) {
        return new Date(tms.year, tms.month - 1, tms.day, tms.hour, tms.minute).getTime()
      },
    },
  }
</script>

<style scoped>
.v-calendar-daily__head {
  margin-left: 17px !important;
  margin-right: 0px !important;
}
.v-event-draggable {
  padding-left: 6px;
}

.v-event-timed {
  user-select: none;
  -webkit-user-select: none;
}

.v-event-drag-bottom {
  position: absolute;
  left: 0;
  right: 0;
  bottom: 4px;
  height: 4px;
  cursor: ns-resize;
}
.v-event-drag-bottom::after {
   display: none;
   position: absolute;
   left: 50%;
   height: 4px;
   border-top: 1px solid white;
   border-bottom: 1px solid white;
   width: 16px;
   margin-left: -8px;
   opacity: 0.8;
   content: '';
 }

.v-event-drag-bottom:hover::after {
   display: block;
 }
.v-event-draggable {
  white-space: normal !important;
  padding: 3px 5px;
  font-size: 11px;
}
</style>

<style scoped lang="scss">
.dc-bar {
  display: grid;
  grid-template-columns: auto 1fr;
  align-items: center;
  gap: 12px;
  height: 44px;
  padding: 0 8px;
  border-bottom: 1px solid rgba(15, 23, 42, .07);
}
.dc-nav, .dc-tools {
  display: flex;
  align-items: center;
  gap: 8px;
  min-width: 0;
}
.dc-tools { justify-content: flex-end; }
.dc-pair {
  display: inline-flex;
  height: 30px;
  border: 1px solid rgba(15, 23, 42, .12);
  border-radius: 6px;
  overflow: hidden;
  .dc-btn { border: 0; border-radius: 0; height: 100%; }
  .dc-btn + .dc-btn { border-inline-start: 1px solid rgba(15, 23, 42, .12); }
}
.dc-btn {
  position: relative;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  height: 30px;
  min-width: 30px;
  padding: 0 6px;
  border: 1px solid rgba(15, 23, 42, .12);
  border-radius: 6px;
  background: #fff;
  color: rgba(15, 23, 42, .75);
  font-size: .8rem;
  .v-icon { color: inherit; }
  &:hover { background: rgba(25, 118, 210, .06); color: var(--v-primary-base, #1976d2); }
  &--text { padding: 0 12px; font-weight: 500; }
  &--icon { border-color: transparent; background: rgba(15, 23, 42, .04); }
  &.is-active { background: rgba(25, 118, 210, .1); color: var(--v-primary-base, #1976d2); }
  &:disabled { opacity: .4; cursor: default; pointer-events: none; }
}
.dc-badge {
  position: absolute;
  top: 4px;
  inset-inline-end: 4px;
  width: 7px;
  height: 7px;
  border-radius: 50%;
  background: var(--v-primary-base, #1976d2);
}
.dc-period {
  font-size: .85rem;
  font-weight: 600;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.dc-date { width: 150px; }
.dc-seg {
  display: inline-flex;
  gap: 2px;
  padding: 2px;
  height: 30px;
  border-radius: 6px;
  background: rgba(25, 118, 210, .08);
}
.dc-seg-opt {
  padding: 0 12px;
  border-radius: 5px;
  font-size: .78rem;
  color: rgba(15, 23, 42, .65);
  white-space: nowrap;
  &:hover { color: var(--v-primary-base, #1976d2); }
  &.is-active {
    background: #fff;
    color: var(--v-primary-base, #1976d2);
    font-weight: 600;
    box-shadow: 0 1px 2px rgba(15, 23, 42, .1);
  }
}
.dc-hint {
  font-size: .75rem;
  padding: 4px 8px;
  border-radius: 6px;
  background: rgba(255, 179, 0, .12);
  color: #8a5a00;
  white-space: nowrap;
}
.dc-menu {
  width: 180px;
  padding: 12px;
  background: #fff;
  border-radius: 6px;
}
.dc-bar ::v-deep .v-input { margin: 0; padding: 0; height: auto !important; }

@media (max-width: 799px) {
  .dc-bar {
    grid-template-columns: 1fr;
    height: auto;
    padding: 6px 8px;
    row-gap: 6px;
  }
  .dc-tools { justify-content: flex-start; flex-wrap: wrap; }
  .dc-date { width: 130px; }
}

.theme--dark {
  .dc-bar { border-color: rgba(255, 255, 255, .08); }
  .dc-btn { background: #1e1e1e; border-color: rgba(255, 255, 255, .12); color: rgba(255, 255, 255, .8); }
  .dc-btn--icon { background: rgba(255, 255, 255, .06); border-color: transparent; }
  .dc-btn.is-active, .dc-btn:hover { background: rgba(100, 181, 246, .14); color: #90caf9; }
  .dc-pair { border-color: rgba(255, 255, 255, .12); }
  .dc-seg { background: rgba(100, 181, 246, .1); }
  .dc-seg-opt { color: rgba(255, 255, 255, .65); }
  .dc-seg-opt.is-active { background: #2a2a2a; color: #90caf9; }
  .dc-menu { background: #1e1e1e; }
  .dc-hint { color: #ffca28; }
}

.dc-more {
  height: 100%;
  min-height: 22px;
  display: flex;
  align-items: flex-start;
  justify-content: center;
  padding-top: 4px;
  border-radius: 6px;
  border: 1px dashed rgba(25, 118, 210, .45);
  background: rgba(25, 118, 210, .08);
  color: var(--v-primary-base, #1976d2);
  font-size: .75rem;
  font-weight: 700;
  cursor: pointer;
  &:hover { background: rgba(25, 118, 210, .16); }
}
.dc-more-list {
  width: 260px;
  padding: 6px;
  background: #fff;
  border-radius: 6px;
}
.dc-more-head { font-size: .75rem; opacity: .6; padding: 4px 8px 6px; }
.dc-more-item, .dc-more-day {
  display: flex;
  align-items: center;
  gap: 8px;
  width: 100%;
  padding: 7px 8px;
  border-radius: 6px;
  font-size: .8rem;
  text-align: start;
  &:hover { background: rgba(25, 118, 210, .08); }
}
.dc-more-dot { flex-shrink: 0; width: 10px; height: 10px; border-radius: 50%; }
.dc-more-name { flex: 1; min-width: 0; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }
.dc-more-time { flex-shrink: 0; font-size: .72rem; opacity: .6; direction: ltr; }
.dc-more-day {
  margin-top: 4px;
  border-top: 1px solid rgba(15, 23, 42, .07);
  border-radius: 0 0 6px 6px;
  color: var(--v-primary-base, #1976d2);
  .v-icon { color: inherit; }
}
.theme--dark {
  .dc-more-list { background: #1e1e1e; }
  .dc-more { color: #90caf9; border-color: rgba(144, 202, 249, .45); background: rgba(144, 202, 249, .1); }
  .dc-more-day { color: #90caf9; border-color: rgba(255, 255, 255, .08); }
}
</style>
